module.exports = __webpack_public_path__ + "img/icon3@2x.562d26b8.png";